// @ts-nocheck
import { createSelector } from 'reselect';

const fullScreenLoaderSelector = (state) => state.global.loader;

const loaderSelector = () =>
  createSelector(fullScreenLoaderSelector, (state) => state.loader);

export { loaderSelector };
